export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function isBgmi(user) {
  return user.user_type === 'brand'
    // brand.id may arrive as a number or a numeric string, so coerce before
    // comparing rather than using === , which would miss the string form.
    ? user.brand.name === 'Battlegrounds India' || Number(user.brand.id) === 78
    : false;
}

// Gate the Creator Marketplace (Meta) source to the "facebook"-linked brand (id 260) only.
export function isCreatorMarketplaceBrand(user) {
  if (!user || user.user_type !== 'brand' || !user.brand) return false;
  return Number(user.brand.id) === 260 || (user.brand.name || '').trim().toLowerCase() === 'facebook';
}

export function isWhatsAppModuleEnable() {
  const user = JSON.parse(localStorage.getItem('user'));
  return user && user.user_type === 'brand' && user.brand && user.brand.whatsapp_communication_enable;
}